import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={21}
    fill="none"
    viewBox="0 0 16 21"
    ref={svgRef}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.5 12.5A2.5 2.5 0 007 10c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7.001 7.001 0 01-11.95 4.95A7 7 0 011 13c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z"
    />
  </Icon>
));
